import i18next from 'i18next'

const generatePdfContentCode = ({ coupon, t, withOffer = true }) => {
  const pageWidth = 596
  const pageHeight = 842

  const contentWidth = pageWidth / 3
  const contentHeight = pageHeight / 3

  return {
    content: [
      {
        text: `${coupon.site.name}`,
        style: 'header'
      },
      {
        canvas: [
          {
            type: 'line',
            x1: 0,
            y1: 0,
            x2: contentWidth + 40,
            y2: 0,
            lineWidth: 0.8,
            lineColor: '#C7C7C7'
          }
        ]
      },
      { text: t('coupons.actions.print_code.pdf.connexion_code'), margin: [28, 8, 0, 0], fontSize: 10 },
      {
        table: {
          widths: ['30%'],
          body: [
            [
              {
                text: `${coupon.code}`,
                style: 'fieldValue',
                fontSize: 10,
                alignment: 'center'
              }
            ]
          ]
        },
        layout: {
          hLineWidth: () => 1,
          vLineWidth: () => 1,
          hLineColor: () => '#3B82F6',
          vLineColor: (i, node) => (i === node.table.widths.length - 1 ? '#3B82F6' : '#3B82F6'),
          paddingTop: () => 8,
          paddingBottom: () => 8
        },
        width: contentWidth,
        height: contentHeight,
        margin: [25, 4, 0, 10]
      },
      ...(withOffer ? [
        { text: t('coupons.actions.print_code.pdf.internet_access'), margin: [28, 0, 0, 0], fontSize: 10 },
        {
          table: {
            widths: ['30%'],
            body: [
              [
                {
                  text: `${
                    coupon.offer?.name
                      ? coupon.offer.name
                      : `${t('coupons.table.validity_col.from')}${new Date(coupon.starts_at).toLocaleDateString(
                        i18next.language
                      )}${t('coupons.table.validity_col.to')}${new Date(coupon.ends_at).toLocaleDateString(
                        i18next.language
                      )} - ${coupon.number_of_devices} ${t('coupons.actions.print_code.pdf.devices')}`
                  }`,
                  style: 'fieldValue',
                  alignment: 'center'
                }
              ]
            ]
          },
          layout: {
            hLineWidth: () => 1,
            vLineWidth: () => 1,
            hLineColor: () => '#3B82F6',
            vLineColor: (i, node) => (i === node.table.widths.length - 1 ? '#3B82F6' : '#3B82F6'),
            paddingTop: () => 8,
            paddingBottom: () => 8
          },
          width: contentWidth,
          height: contentHeight,
          margin: [25, 4, 0, 10]
        },
      ]: []),
      {
        ol: [
          { text: t('coupons.actions.print_code.pdf.helper.other'), margin: [0, 0, 0, 2] },
          { text: t('coupons.actions.print_code.pdf.helper2'), margin: [0, 0, 0, 2] },
          { text: t('coupons.actions.print_code.pdf.helper3'), margin: [0, 0, 0, 2] }
        ],
        margin: [12, 0, 0, 8],
        fontSize: 8
      },
      {
        canvas: [
          {
            type: 'line',
            x1: 0,
            y1: 0,
            x2: contentWidth + 40,
            y2: 0,
            lineWidth: 1,
            lineColor: '#C7C7C7'
          }
        ]
      },
      {
        canvas: [
          {
            type: 'line',
            x1: contentWidth + 40,
            y1: 0,
            x2: contentWidth + 40,
            y2: contentHeight - 30,
            lineWidth: 0.5,
            lineColor: 'black',
            dash: { length: 3, space: 2 }
          }
        ],
        absolutePosition: { x: 0, y: 0 }
      },
      {
        text: t('coupons.actions.print_code.pdf.customer_service'),
        margin: [85, 8, 0, 0],
        fontSize: 10
      },
      { text: coupon.hotline_number ? coupon.hotline_number : '01 70 70 46 26', margin: [85, 6, 0, 0], fontSize: 10 },
      {
        canvas: [
          {
            type: 'line',
            x1: 0,
            y1: contentHeight - 30,
            x2: contentWidth + 40,
            y2: contentHeight - 30,
            lineWidth: 0.5,
            lineColor: 'black',
            dash: { length: 3, space: 3 }
          }
        ],
        absolutePosition: { x: 0, y: 0 }
      }
    ],

    styles: {
      header: {
        fontSize: coupon.site.name.length > 35 ? 10 : coupon.site.name.length > 30 ? 12 : 14,
        margin: coupon.site.name.length > 35 ? [10, 8, 0, 10] : [20, 8, 0, 10],
        widths: contentWidth
      },
      fieldValue: {
        fontSize: coupon?.offer?.name.length > 50 ? 8 : 10,
        bold: true,
        alignment: 'center'
      }
    },
    pageMargins: [0, 0],
    pageSize: { width: pageWidth, height: pageHeight }
  }
}

export default generatePdfContentCode
